define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    ViewController.plugin({
        supportLogger: true,
        logger: WebAgentLogger.getLogger("ViewController"),

        initialize: function () {
            this.logger = (function (context) {
                var controllerName = context.ControllerName || "ViewController(undefined)";
                return WebAgentLogger.getLogger(controllerName);
            })(this);
        }
    });

    // todo - what to export?

});
